import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

const faqItems = [
  {
    question: "What is a TikTok collection?",
    answer: "A TikTok collection is a curated list of TikTok videos that users can create and share. It's a way to organize and group related content from different creators."
  },
  {
    question: "How do I use TokCollection?",
    answer: "Simply paste your TikTok collection URL into our tool, select your preferred download options, and click download. We'll process the videos and prepare them for download in your chosen format."
  },
  {
    question: "Do you support bulk downloads?",
    answer: "Yes! You can download entire collections at once. Our system is optimized to handle multiple videos efficiently while maintaining the best possible quality."
  },
  {
    question: "What file types are exported?",
    answer: "We support MP4 video downloads, and can also provide optional spreadsheet exports with video metadata, captions, and other relevant information."
  },
  {
    question: "Is this safe and legal?",
    answer: "Yes, our service complies with TikTok's terms of service. We only process publicly available content and respect all copyright and usage rights."
  }
];

const FAQ = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-[#0F111A] to-[#151823]">
      <div className="max-w-3xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1C2538]/40 border border-[#2A3547] backdrop-blur-sm">
            <HelpCircle className="w-4 h-4 text-[#00E5FF]" />
            <span className="text-[#00E5FF] text-sm font-medium tracking-wider uppercase">
              FAQ
            </span>
          </div>
          <h2 className="text-3xl font-bold text-white mt-4 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-400">
            Everything you need to know about TokScript and how it works
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqItems.map((item, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border border-gray-800 rounded-lg bg-[#1A1E2C]/50 px-6"
            >
              <AccordionTrigger className="text-white hover:text-[#00E5FF] hover:no-underline">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-400">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
